import messages from "i18n/messages";
import classNames from "classnames";
import flowRight from "lodash/flowRight";
import { makeSelectEventById } from "logic/events";
import { makeSelectCurOrg } from "logic/orgs";
import moment from "moment";
import Link from "next/link";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Skeleton } from "./index";

function Actions({ showMore, org, date }) {
  if (date.cancelled)
    return (
      <div className="btn btn-link last-el cancelled-btn">
        {!process.env.HZL_INST ? (
          <FormattedMessage {...messages.dateNotAvailable} />
        ) : (
          <FormattedMessage {...messages.cancelled} />
        )}
      </div>
    );

  return (
    <>
      {showMore ? (
        <Link href={`/${org.odn}/e/${date.event_id}`}>
          <a
            href={`/${org.odn}/e/${date.event_id}`}
            className="more last-el btn btn-link"
          >
            <span className="tt-icon tt-icon-dots-filled" />
          </a>
        </Link>
      ) : null}
      {moment(date.starts_at).subtract(date.sale_ends_min_before, "minutes") >=
        moment() &&
      !date.sold_out &&
      date.pub_available_qty ? (
        <Link href={`/${org.odn}/b/${date.id}`}>
          <a
            href={`/${org.odn}/b/${date.id}`}
            className={`btn btn-primary get-tickets${
              showMore ? "" : " last-el"
            }`}
          >
            <FormattedMessage {...messages.tickets} />
          </a>
        </Link>
      ) : null}
      {moment(date.starts_at).subtract(date.sale_ends_min_before, "minutes") <
      moment() ? (
        <div
          className={`btn btn-default btn-disabled get-tickets${
            showMore ? "" : " last-el"
          }`}
        >
          <FormattedMessage {...messages.salesClosed} />
        </div>
      ) : null}
      {moment(date.starts_at).subtract(date.sale_ends_min_before, "minutes") >=
        moment() &&
      (date.sold_out || date.pub_available_qty < 1) ? (
        <div
          className={`btn btn-default btn-disabled get-tickets${
            showMore ? "" : " last-el"
          }`}
        >
          <FormattedMessage {...messages.soldOut} />
        </div>
      ) : null}
    </>
  );
}

function BookGoods({ org, date }) {
  if (
    date.product_sale_ends_minutes_before &&
    moment(date.starts_at).subtract(
      date.product_sale_ends_minutes_before,
      "minutes"
    ) < moment()
  )
    return (
      <div
        className={`btn btn-default btn-disabled get-tickets${
          showMore ? "" : " last-el"
        }`}
      >
        <FormattedMessage {...messages.salesClosed} />
      </div>
    );

  return (
    <Link href={`/${org.odn}/goods?did=${date.id}`}>
      <a
        href={`/${org.odn}/goods?did=${date.id}`}
        className="btn btn-primary get-tickets last-el"
      >
        <FormattedMessage {...messages.goodsPreOrder} />
      </a>
    </Link>
  );
}

class DateListItem extends Component {
  render() {
    const { date, event, org, bookGoods } = this.props;
    const starts_at = date ? moment(date.starts_at) : null;
    const thisDateTimeStr = date ? (
      moment(date.starts_at).format("HH:mm")
    ) : (
      <Skeleton />
    );
    return (
      <div
        className={classNames("date-list-item", { cancelled: date.cancelled })}
      >
        <div className="date-box">
          <div className="month">
            {date ? starts_at.format("MMMM") : <Skeleton />}
          </div>
          <div className="day">
            {date ? starts_at.format("DD") : <Skeleton />}
          </div>
        </div>
        <div className="time-box">
          <div className="weekday">
            {date ? starts_at.format("dddd") : <Skeleton />}
          </div>
          <div className="time">
            {date && !date.all_day ? thisDateTimeStr : null}
          </div>
        </div>
        <div className="date-title">
          <Link href={`/${org.odn}/b/${date.id}`}>
            <a href={`/${org.odn}/b/${date.id}`}>
              {event ? event.title : <Skeleton />}
            </a>
          </Link>
          <div className="date-subtitle">
            {event ? event.subtitle : <Skeleton />}
          </div>
        </div>
        {bookGoods ? (
          <BookGoods {...this.props} />
        ) : (
          <Actions {...this.props} />
        )}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  event: makeSelectEventById((props) => props.date.event_id),
  org: makeSelectCurOrg(),
});

const enhance = flowRight(connect(mapStateToProps));

export default enhance(DateListItem);
